import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { difference, chain } from 'lodash';
import MySelect from '@/components/MySelect.vue';
const standardArray = [15, 14, 13, 12, 10, 8];
const pointMap = {
    0: 0,
    8: 0,
    9: 1,
    10: 2,
    11: 3,
    12: 4,
    13: 5,
    14: 7,
    15: 9
};
let CharacterBuilderAbilityScores = class CharacterBuilderAbilityScores extends Vue {
    get remainingPoints() {
        return 27 - Object.values(this.currentScores).reduce((acc, score) => acc + pointMap[score], 0);
    }
    getOptions(currentValue) {
        if (this.abilityScoreMethod === 'Standard Array') {
            const current = currentValue > 0 ? [currentValue] : [];
            return [...current, ...difference(standardArray, Object.values(this.currentScores))];
        }
        else {
            return chain(Object.keys(pointMap))
                .map(score => ({ value: parseInt(score), text: `${score} (${pointMap[score]} points)` }))
                .filter(({ value }) => {
                const isAbleToAfford = pointMap[value] <= this.remainingPoints + pointMap[currentValue];
                return (value === currentValue || isAbleToAfford) && value > 0;
            })
                .value();
        }
    }
    checkAbilityScore(score) {
        return (score > 20 && 'Must be less than 21') ||
            (score < 1 && 'Must be greater than 0');
    }
    handleChangeAbilityScore(ability, score) {
        this.$emit('updateCharacter', { baseAbilityScores: { [ability]: score || 0 } });
    }
};
__decorate([
    Prop(String)
], CharacterBuilderAbilityScores.prototype, "abilityScoreMethod", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderAbilityScores.prototype, "currentScores", void 0);
CharacterBuilderAbilityScores = __decorate([
    Component({
        components: {
            MySelect
        }
    })
], CharacterBuilderAbilityScores);
export default CharacterBuilderAbilityScores;
